import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import FormLogin from "../forms/FormLogin";

function Login(props) {

  useEffect(() => {
    window.document.title = props.title;
  }, [props.title]);

  return (
    <main className="login">
      <h1 className="title">Login</h1>
      <FormLogin />
      <Link to="/password/request">Passwort zurücksetzen</Link>
    </main>
  );
}
export default Login;
